import React from 'react'
import { Head, Link, useForm } from '@inertiajs/react'
import { Container, Typography, Box, Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import GroupForm from './Form'

interface Company {
  id: number
  name: string
}

interface Member {
  id: number
  name: string
  stage_name: string | null
}

interface Group {
  id: number
  name: string
  company: Company
  gender: string
  group_type: string
  description: string | null
  members: Member[]
}

interface Props {
  group: Group
  companies: Company[]
}

export default function EditGroup({ group, companies }: Props) {
  const { data, setData, patch, processing, errors } = useForm({
    name: group.name,
    company_id: String(group.company.id),
    gender: group.gender,
    group_type: group.group_type,
    description: group.description || '',
    members_attributes: group.members.map((m) => ({
      id: m.id,
      name: m.name,
      stage_name: m.stage_name || '',
    })),
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(`/groups/${group.id}`, { data: { group: data } })
  }

  return (
    <>
      <Head title={`Edit ${group.name}`} />
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Box sx={{ mb: 4 }}>
          <Button
            component={Link}
            href={`/groups/${group.id}`}
            startIcon={<ArrowBackIcon />}
            sx={{ mb: 2 }}
          >
            Back to {group.name}
          </Button>
          <Typography variant="h5">Edit {group.name}</Typography>
        </Box>

        <GroupForm
          data={data}
          setData={setData}
          errors={errors as Record<string, string[]>}
          companies={companies}
          processing={processing}
          onSubmit={handleSubmit}
          submitLabel="Update Group"
        />
      </Container>
    </>
  )
}
